import { Grid } from "@mui/material";
import React from "react";
import "./About2.css";

const About2 = () => {
  const exp_info = [
    "React.Js",
    "Next.Js",
    "CSS3",
    "Bootstrap",
    "HTML5",
    "JavaScript",
    "Node.Js",
    "Express.Js",
    "MySql",
    "MongoDB",
    "Data Structure",
    "Algorithm",
    "Tailwind CSS",
    "Material UI",
    "Firebase",
    "Github",
    "Graphic Design",
    "illustrator",
    "Redux",
  ];

  return (
    <div className="BG2">
      <div className="container">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <h2 className="h">Education</h2>
            <div className="box-exp exp1">
              <ul>
                <li style={{ color: "white" }} className="li-style">
                  <p className="year">2020-2023</p>
                  <h5>B.Sc in CSE</h5>
                  <p>Daffodil International University</p>
                </li>
                <li style={{ color: "white" }} className="li-style">
                  <p className="year">2016-2018</p>
                  <h5>Higher Secondary Certificate</h5>
                  <p>Birshreshtha Noor Mohammad Public College</p>
                </li>
                <li style={{ color: "white" }} className="li-style">
                  <p className="year">2011-2016</p>
                  <h5>Secondary School Certificate</h5>
                  <p>B.M Union High School</p>
                </li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <h2 className="h">Experience</h2>
            <div className="box-exp exp2">
              <ul>
                <li style={{ color: "white" }} className="li-style">
                  <p className="year">2023-{new Date().getFullYear()}</p>
                  <h5>Junior Software Engineer at Traideas</h5>
                  <ul>
                    <li>
                      <p>
                        → Managing Front-end and Back-end in various projects.
                      </p>
                    </li>
                    <li>
                      <p>→ Made some important modules in the back end.</p>
                    </li>
                    <li>
                      <p>→ Continuous Testing for Code Resilience.</p>
                    </li>
                    <li>
                      <p>→ Bug fixing.</p>
                    </li>
                    <li>
                      <p>→ R&D for Optimal Code Performance.</p>
                    </li>
                  </ul>
                </li>
                <li style={{ color: "white" }} className="li-style">
                  <p className="year">2018-{new Date().getFullYear()}</p>
                  <h5>Graphic Designer</h5>
                  <p>Freelancing</p>
                </li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <h2 className="h">Skill</h2>
            <div className="box-exp-skill">
              <Grid container spacing={3}>
                {exp_info.map((data) => (
                  <Grid item xs={6} md={4} lg={4}>
                    <div className="skill-set">
                      {" "}
                      <h5 style={{ marginLeft: "7px", fontWeight: "bold" }}>
                        {data}
                      </h5>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default About2;
